import type { RetrieveFeatureFlagsResponse } from '$shared/api';
import { BaseService } from './utils/BaseService';

export class FeatureService extends BaseService {
  getFeatureFlags(): Promise<RetrieveFeatureFlagsResponse> {
    return this.client.send('/api/feature-flags', {
      method: 'GET',
    });
  }
}
